import { Storage } from "./amplifyCompat";

const TRANSLATIONS = ['fr','es'];
const NO_CREDENTIALS_MESSAGE = 'Credentials should not be empty.';

const isMissingCredentialsError = (error) =>
  error?.name === 'NoCredentials' ||
  error?.message?.includes(NO_CREDENTIALS_MESSAGE);

export const getAllTranslations = async () => {
    try {
        const translations = await Promise.all(TRANSLATIONS.map(async (langCode) => {
            const translation = await Storage.get(`translations/${langCode}.json`, { download: true, validateObjectExistence: true, contentType: 'application/json', cacheControl: 'no-cache' });
            const translationJSON = await new Response(translation.Body).json();
            return { langCode, translationJSON };
        }));
        return translations;
    } catch (error) {
        if (isMissingCredentialsError(error)) {
            return [];
        }

        throw error;
    }
};


export const updateTranslationWithLangCode = async (langCode, translationObject) => {
    await Storage.put(`translations/${langCode}.json`, JSON.stringify(translationObject), {
        contentType: 'application/json',
    });
}
